const Loading = () => (
  <div className="loading main" />
);
export default Loading;
